import { BannerComponent } from './banner.component';
import { ITrackingAction, ITrackingObject } from 'i2g-ng-tracking';

export interface IBanner {
  id?: string;
  emitEvent?: boolean;
  message?: string;
  containsHtml?: boolean;
  dismissible?: boolean;
  onDestroy?: (bannerId: string, component: BannerComponent) => void;
  onDismiss?: (bannerId: string, component: BannerComponent) => void;
  onAction?: (bannerId: string, component: BannerComponent) => void;
  onShow?: (bannerId: string, component: BannerComponent) => void;
  bannerDestination?: string;
  trackingObject?: ITrackingObject;
  trackingAction?: ITrackingAction;
  trackingScreenName?: string;
  persistent?: boolean;
  isSticky?: boolean;
  e2eId?: string;
}

export interface IBannerTrigger {
  type?: BannerTypesEnum;
  action: BannerActionsEnum;
  banner?: IBanner;
}

export enum BannerTypesEnum {
  info = 'info',
  error = 'error',
}

export enum BannerActionsEnum {
  show = 'show',
  hide = 'hide',
}
